
import { Loader } from '@googlemaps/js-api-loader'
import { getAddress, getFormattedAddress } from '~/ZenOne-StoryBook/helpers/maps'

export default {
  name: 'AddressInput',
  props: {
    address: {
      type: Object
    },
    label: {
      type: String
    }
  },
  data() {
    return {
      input: '',
      result: '',
      autocomplete: null
    }
  },
  computed: {},
  mounted() {
    const formattedAddress = getFormattedAddress(this.address)
    if (formattedAddress) {
      this.result = formattedAddress
      this.$emit('validation', true)
    }
    this.initAutocomplete()
  },
  watch: {},
  methods: {
    async initAutocomplete() {
      const loader = new Loader({
        apiKey: process.env.gmapsApiKey,
        libraries: ['places']
      })
      const google = await loader.load()
      const inputElement = this.$refs.input.$el.querySelector('input')

      this.autocomplete = new google.maps.places.Autocomplete(
        inputElement,
        { types: ['geocode'] }
      )

      this.autocomplete.addListener('place_changed', this.onPlaceChanged)

      this.$nextTick(() => inputElement.setAttribute('placeholder', ''))
    },
    async onPlaceChanged() {
      const place = await this.autocomplete.getPlace()
      const data = getAddress(place.address_components, '', {}, place.adr_address)
      this.result = getFormattedAddress(data)
      this.$emit('validation', true)
      this.$emit('set', data)
    },
    focusInput() {
      this.result = ''
      this.$emit('validation', false)
      this.$emit('set', {})
      this.$nextTick(() => this.$refs.input.$el.querySelector('input').click())
    }
  }
}
